import BaseService from './BaseService';
import RequestPool from './RequestPool';
import serviceUtils from './utils';

const defaultEndpoints = {
  me: '/me',
};

export default class UserService extends BaseService {
  meRequestPool: RequestPool;

  constructor(endpoints: any, forceAgentHeader = false) {
    super(serviceUtils.mergeObjects(defaultEndpoints, endpoints), forceAgentHeader);

    this.meRequestPool = new RequestPool();
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  delToken() {
    localStorage.removeItem('token');
  }

  _makeAuthRequest(method, path, body, headers, callback) {
    const token = this.getToken();

    if (!token) {
      return callback(new Error('No access token. Login required.'));
    }

    headers = headers || {};
    headers.Authorization = 'Bearer ' + token;
    super._makeRequest(method, path, body, headers, callback);
  }

  _unwrapAccountResult(callback) {
    return (err, result) => {
      if (err) {
        return callback(err);
      }

      callback(null, result.account || result || {});
    };
  }

  me(callback) {
    this.meRequestPool.request((resultCallback) => {
      this._makeAuthRequest('get', this.endpoints.me, null, null, this._unwrapAccountResult(resultCallback));
    }, callback);
  }

  updateProfile(data, callback) {
    this._makeAuthRequest('post', this.endpoints.me, data, null, callback);
  }
}
